import React from 'react';
import { Dialog, Table, TableRow } from '@material-ui/core';
import { CoreIcon } from '@clover/web-lib-core/components';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

interface ComponentProps {
  onClose: () => void;
  readWritePermissions: {
    categoryTranslation: string;
    requiredKey: string;
  }[];
}

export const ViewPermissionsModal = (props: ComponentProps): JSX.Element => {
  const { onClose, readWritePermissions } = props;
  const [t] = useTranslation();

  const handleClose = () => {
    onClose();
  };
  const prefix = 'app_details.';

  return (
    <Dialog
      onClose={handleClose}
      open={true}
      maxWidth={false}
      PaperProps={{ classes: { root: styles.readWritePermissions } }}
    >
      <CoreIcon
        className={styles.closeIcon}
        onClick={handleClose}
        glyph="close"
        height={14}
        width={14}
        role="application"
		data-testid='closePermissionModal'
      />
      <div className={styles.modalContent}>
        <h4>{t('app_details.requested_permissions')}</h4>
        <Table>
          {readWritePermissions.map(permission => (
            <div className={styles.permissionSpacing}>
              <TableRow>
                <p>{t(prefix + permission.requiredKey, { permission: t(permission.categoryTranslation) })}</p>
              </TableRow>
            </div>
          ))}
        </Table>
      </div>
    </Dialog>
  );
};
